function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1"
}, /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#72ACFE",
  cx: 5.52,
  cy: 5.52,
  r: 5.52
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFF",
  d: "M2.83 5.54c-0.19,-0.92 1.19,-1.18 1.36,-0.32 0.09,0.43 -0.21,0.78 -0.54,0.84 -0.42,0.07 -0.75,-0.22 -0.82,-0.52zm5.38 0.03c-0.27,0.89 -1.62,0.49 -1.33,-0.4 0.28,-0.86 1.59,-0.45 1.33,0.4zm-3.37 -0.07c-0.13,-0.95 1.24,-1.08 1.37,-0.24 0.15,0.95 -1.25,1.06 -1.37,0.24zm0.54 4.16l0 -0.95c0.43,-0.09 0.73,0.04 1.63,-0.25 0.49,-0.16 0.87,-0.36 1.24,-0.64 1.65,-1.2 1.77,-3.57 -0.08,-4.95 -0.75,-0.55 -1.77,-0.88 -2.95,-0.82 -1.99,0.1 -4,1.63 -3.66,3.82 0.17,1.11 0.9,1.72 1.59,2.2 0.34,0.25 2.01,1.51 2.23,1.59z"
}));

var SvgChatme = function SvgChatme(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 11.04 11.04",
    xmlnsxodm: "http://www.corel.com/coreldraw/odm/2003",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatme, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chatme.ebc56cc0.svg";
export { ForwardRef as ReactComponent };